import { Instagram, Facebook, Phone, Mail } from "lucide-react";
import { CONTACT, NAV_LINKS } from "@/data";
import logo from "@/assets/vistara-logo-color.png";

export const Footer = () => {
  const go = (href) => document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  return (
    <footer data-testid="footer" className="bg-charcoal-muted text-cream pt-20 md:pt-28 overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 pb-16 border-b border-cream/10">
          <div>
            <div className="inline-block bg-cream rounded-md px-4 py-3 mb-5">
              <img src={logo} alt={CONTACT.name} className="w-32 md:w-36" />
            </div>
            <p className="font-sans text-sm text-cream/60 leading-relaxed max-w-xs">
              {CONTACT.address}
            </p>
          </div>

          <div>
            <p className="text-xs uppercase tracking-[0.25em] text-amber mb-5">Explore</p>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <button
                    data-testid={`footer-link-${l.label.toLowerCase()}`}
                    onClick={() => go(l.href)}
                    className="font-sans text-cream/70 hover:text-amber transition-colors"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="text-xs uppercase tracking-[0.25em] text-amber mb-5">Reach us</p>
            <ul className="space-y-3 font-sans text-cream/70">
              <li>
                <a data-testid="footer-phone" href={`tel:${CONTACT.phone.replace(/\s/g, "")}`} className="inline-flex items-center gap-3 hover:text-amber transition-colors">
                  <Phone size={16} strokeWidth={1.5} /> {CONTACT.phone}
                </a>
              </li>
              <li>
                <a data-testid="footer-email" href={`mailto:${CONTACT.email}`} className="inline-flex items-center gap-3 hover:text-amber transition-colors">
                  <Mail size={16} strokeWidth={1.5} /> {CONTACT.email}
                </a>
              </li>
            </ul>
            <div className="flex gap-4 mt-6">
              <a data-testid="footer-instagram" href={CONTACT.instagram} target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full border border-cream/20 flex items-center justify-center hover:bg-amber hover:text-charcoal transition-all duration-300">
                <Instagram size={17} strokeWidth={1.5} />
              </a>
              <a data-testid="footer-facebook" href={CONTACT.facebook} target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full border border-cream/20 flex items-center justify-center hover:bg-amber hover:text-charcoal transition-all duration-300">
                <Facebook size={17} strokeWidth={1.5} />
              </a>
            </div>
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-between gap-3 py-8 text-xs text-cream/40 font-sans uppercase tracking-widest">
          <span>&copy; {new Date().getFullYear()} {CONTACT.name}</span>
          <span>Wake up above the clouds</span>
        </div>
      </div>

      <div className="leading-none select-none pointer-events-none">
        <h2 className="font-serif text-center text-[26vw] md:text-[22vw] text-cream/[0.05] -mb-[4vw]">
          Vistara
        </h2>
      </div>
    </footer>
  );
};
